<div *ngIf="!(path == 'speaker' && currentLayout == 'l_banner')">
    <div class="col-sm-12">
        <div class="form-group">
            <label for="basedOnData">Based on Data</label>
            <ccl-simple-select formId="basedOnData"
                [listOfItems]="basedOnDatas"
                (valueChange)="imageConfig.basedOn = $event.value"
                [value]="imageConfig.basedOn"
                [bindValue]="'code'"
                [bindLabel]="'label'"
                [isClearable]="false"
            ></ccl-simple-select>
        </div>
    </div>
</div>
<div
    class="row"
    *ngIf="(currentLayout == 'l_circular' || currentLayout == 'l_square') && imageConfig.basedOn === 'speaker_img'"
>
    <div class="col-sm-12">
        <div class="image-example">
            <span> Image Example </span> <br />
            <img alt="Image Example"
                src="assets/images/blank_profile.jpg"
                [ngStyle]="{
                    height: imageConfig.height,
                    width: imageConfig.width,
                    'background-color': imageConfig.background,
                    margin: imageConfig.margin,
                    'border-radius': currentLayout == 'l_circular' ? imageConfig.height : '0px'
                }"
            />
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayWidth">Display Width</label></div>
            <input id="displayWidth"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.width"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayHeight">Display Height</label></div>
            <input id="displayHeight"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.height"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regionMargin">Region Margin</label></div>
            <input id="regionMargin"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlayColor">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlayColor"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="currentLayout == 'l_banner' && imageConfig.basedOn !== 'thumbnail_img'">
    <div class="col-sm-12">
        <ccl-image-upload
            (imageChange)="imageChange($event)"
            (uploadEvent)="uploadEvent($event)"
            [image]="imageConfig.banner"
        ></ccl-image-upload>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regionMargin2">Region Margin</label></div>
            <input id="regionMargin2"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlayColor2">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlayColor2"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="imageConfig.basedOn === 'dynamic_img' && currentLayout != 'l_banner'">
    <div class="col-sm-12">
        <ccl-image-upload
            (imageChange)="imageChange($event)"
            (uploadEvent)="uploadEvent($event)"
            [image]="imageConfig.dynamicImage"
        ></ccl-image-upload>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayWidth3">Display Width</label></div>
            <input id="displayWidth3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.width"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayHeight3">Display Height</label></div>
            <input id="displayHeight3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.height"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regionMargin3">Region Margin</label></div>
            <input id="regionMargin3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlayColor3">Image overlay Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlayColor3"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="row" *ngIf="imageConfig.basedOn === 'thumbnail_img'">
    <div class="col-sm-12">
        <div class="c-image-thumb" >
        <img class="img-fluid" src="{{imageConfig.defaultThumbnailURL}}" alt="Session Thumbnail">
        <span class="thumb-display-icon" *ngIf="html" [innerHTML]="html"></span>
    </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group">
            <label for="displayWithicon">Display with icon</label>
            <textarea id="displayWithicon"
                rows="4"
                type="text"
                class="form-control c-input--required"
                (keyup)="onIconChange()"
                [(ngModel)]="imageConfig.displayIcon"
            ></textarea>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group">
            <label for="noImageSession">If no image exists for this session, use...</label>
            <input id="noImageSession"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.defaultThumbnailURL"
            />
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayWidth3">Display Width</label></div>
            <input id="displayWidth3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.width"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="displayHeight3">Display Height</label></div>
            <input id="displayHeight3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.height"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regionMargin3">Region Margin</label></div>
            <input id="regionMargin3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.margin"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="roundCorner3">Rounded Corners</label></div>
            <input id="roundCorner3"
                cclFormInput
                type="text"
                class="c-form-group__input c-input--required"
                [(ngModel)]="imageConfig.corners"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="overlayColor3">Background Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="imageConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="overlayColor3"
                    cclFormInput
                    type="text"
                    [(ngModel)]="imageConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': imageConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
